<template>
  <div class="logo">
    <div style="display: block; display: flex; height: 40px; align-items: center;">
      <menu-icon v-if="showTitle" class="normal-logo" type="hi-tongyiqiaocailogo" :cusStyles="customStyle" />
      <menu-icon v-if="!showTitle" class="mini-logo" type="hi-tongyiqiaocailogo" :cusStyles="customStyle" />
    </div>
  </div>
</template>

<script>
import MenuIcon from '@/components/common-icon/MenuIcon'

export default {
  name: 'Logo',
  components: {
    MenuIcon
  },
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data () {
    return {
      customStyle: {
        color: '#ffffff',
        verticalAlign: 'top',
        fontSize: '26px'
      }
    }
  }
}
</script>
